import React, { useState } from 'react';
import { FaEye, FaCheck, FaTimes, FaChevronDown, FaChevronLeft } from 'react-icons/fa';

const LivePreview = ({ preferences, onPreferencesChange, onGroupSelect }) => {
    // ✅ 1. State now holds an ARRAY of expanded group numbers
    const [expandedGroups, setExpandedGroups] = useState([]);

    const styles = {
    container: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '0.67rem' // Was 1rem
    },
    title: { 
        fontSize: '1rem', // Was 1.5rem
        fontWeight: 'bold', 
        color: 'white', 
        textAlign: 'center', 
        marginBottom: '0.67rem' // Was 1rem
    },
    scrollContainer: {
        maxHeight: '75vh', // Keeping this relative to the screen is best
        overflowY: 'auto',
        padding: '0 0.34rem', // Was 0 0.5rem
    },
    groupContainer: { 
        marginBottom: '0.67rem', // Was 1rem
    },
    groupTitle: { 
        fontSize: '0.8rem', // Was 1.2rem
        fontWeight: 'bold', 
        color: 'white',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem', // Was 0.75rem
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '3px', // Was 4px
        userSelect: 'none',
    },
    itemsContainer: { 
        paddingTop: '0.34rem', // Was 0.5rem
        display: 'flex',
        flexDirection: 'column',
        gap: '0.34rem', // Was 0.5rem
    },
    button: { 
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
      padding: '0.5rem 0.67rem', // Was 0.75rem 1rem
      backgroundColor: 'rgba(0, 0, 0, 0.2)', 
      border: '1px solid rgba(255, 255, 255, 0.2)', 
      borderRadius: '3px', // Was 4px
      fontSize: '0.8rem', // Was 1rem
      color: 'white'
    },
    itemDetails: { 
        display: 'flex', 
        alignItems: 'center', 
        gap: '0.34rem' // Was 0.5rem
    },
    icon: { 
        fontSize: '0.8rem' // Was 1.2rem
    },
    deleteIcon: { 
        color: '#ff6b6b', 
        cursor: 'pointer' 
    },
    groupNumberText: { 
        fontSize: '0.6rem', // Was 0.9rem
        color: '#ccc', 
        fontWeight: 'normal', 
        marginRight: '0.34rem' // Was 0.5rem
    },
    itemCharText: { 
        fontSize: '0.6rem', // Was 0.9rem
        color: '#ccc', 
        fontWeight: 'normal' 
    }
};
    // ✅ 2. The click handler now adds or removes the group from the array
    const handleGroupClick = (groupNumber) => {
        setExpandedGroups(prevExpanded => {
            // If the group is already in the array, remove it (collapse)
            if (prevExpanded.includes(groupNumber)) {
                return prevExpanded.filter(gn => gn !== groupNumber);
            } else {
                // Otherwise, add it to the array (expand)
                return [...prevExpanded, groupNumber];
            }
        });
        
        // This part remains the same, it still updates the Preferences dropdown
        if (onGroupSelect) {
            onGroupSelect(groupNumber);
        }
    };

    const handleDelete = (groupNumber, itemIndex) => {
        const newPreferences = JSON.parse(JSON.stringify(preferences));
        const groupIndex = newPreferences.groups.findIndex(g => g.group_number === groupNumber);
        if (groupIndex === -1) return;

        const itemToUpdate = newPreferences.groups[groupIndex].items[itemIndex];
        if (itemToUpdate) {
            itemToUpdate.is_visible = false;
            itemToUpdate.is_selectable = false;
            onPreferencesChange(newPreferences);
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>پیش‌نمایش زنده</h2>
            <div style={styles.scrollContainer}>
                {preferences?.groups.map(group => {
                    const hasVisibleItems = group.items.some(item => item.is_visible || item.is_selectable);
                    if (!hasVisibleItems) return null;

                    // ✅ 3. Check if the current group's number is in our array
                    const isExpanded = expandedGroups.includes(group.group_number);

                    return (
                        <div key={group.group_number} style={styles.groupContainer}>
                            <div style={styles.groupTitle} onClick={() => handleGroupClick(group.group_number)}>
                                <span>
                                    {group.group_title}
                                    <span style={styles.groupNumberText}>({group.group_number})</span>
                                </span>
                                {isExpanded ? <FaChevronDown /> : <FaChevronLeft />}
                            </div>

                            {isExpanded && (
                                <div style={styles.itemsContainer}>
                                    {group.items.map((item, index) => {
                                        if (!item.is_visible && !item.is_selectable) return null;
                                        return (
                                            <div key={index} style={styles.button}>
                                                <div style={styles.itemDetails}>
                                                    <FaTimes 
                                                        style={{ ...styles.icon, ...styles.deleteIcon }} 
                                                        onClick={() => handleDelete(group.group_number, index)}
                                                    />
                                                    <span>{item.item_sign}</span>
                                                    <span>{item.item_title}</span>
                                                    <span style={styles.itemCharText}>({item.item_char})</span>
                                                </div>
                                                <div>
                                                    <FaEye style={{ ...styles.icon, color: item.is_visible ? 'green' : 'gray' }} />
                                                    <FaCheck style={{ ...styles.icon, color: item.is_selectable ? 'green' : 'gray' }} />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LivePreview;